module.exports = __webpack_public_path__ + "img/key_features--comfort.edc753c7.png";